export const tabs = {
    free: "#tab=free",
    fixed: "#tab=fixed",
    ended: "#tab=ended",
    deleted: "#tab=deleted",
};
